export class LocationType {
    id = null;

    description = '';
}
